import { GetterTree } from "vuex";
import { IPracticeState as PracticeState } from "@/store/modules/practice/types";
import { RootState } from "@/store/types";
import { IContentSection } from "@/store/modules/content/types";

type PracticeGetterTree = GetterTree<PracticeState, RootState>;

export const getters: PracticeGetterTree = {
  nextSection(state: PracticeState): string {
    const nextSection = Object.entries(state.completedSections)
      .filter(s => !Object.values(s[1] as IContentSection).length)
      .map(s => s[0])
      .shift();

    return nextSection || "";
  },

  isSectionsFinished(state: PracticeState): boolean {
    return Object.entries(state.completedSections).every(
      obj => obj[1] && Object.values(obj[1] as IContentSection).length
    );
  },

  completedSections(state: PracticeState): {} {
    return state.completedSections;
  },

  isOngoingSection(state: PracticeState): boolean {
    return Object.entries(state.completedSections).some(
      obj => obj[1] && Object.values(obj[1] as IContentSection).length
    );
  },

  getSection(state: PracticeState): any {
    const { section } = state;
    if (section) {
      return section;
    }
  },

  getSections(state: PracticeState): any {
    const { sections } = state;
    if (sections) {
      return sections;
    }
  },
};
